import { OrganisationPermissionsType } from 'worldover/hooks/use-get-permissions/use-get-permissions';
import { Icon, Text } from 'worldover/ui-components';

import {
  useIngredientsRoute,
  useRegulationsRoute,
  useSingleFormulationLink,
} from '@/hooks';

import { LandingPageFreeTierCard } from './LandingPageFreeTierCard';

interface Props {
  organisationPermissions: OrganisationPermissionsType;
}

export const LandingPageFreeTierHome = ({ organisationPermissions }: Props) => {
  const singleFormulationLink = useSingleFormulationLink({
    organisationPermissions,
  });
  const ingredientsRoute = useIngredientsRoute();
  const regulationsRoute = useRegulationsRoute();

  const {
    onClick,
    href,
    formulationName,
    isLoadingFormulation,
    isCreatingFormulation,
  } = singleFormulationLink;

  return (
    <div className='flex flex-col gap-[20px]'>
      <div className='flex flex-col gap-[14px]'>
        <div className='flex flex-row gap-2'>
          <Icon name='Home' height={18} width={18} className='text-slate-400' />
          <Text variant='bodySemi' color='text-slate-400'>
            Home
          </Text>
        </div>
        <div className='flex flex-row gap-[20px]'>
          {formulationName ? (
            <LandingPageFreeTierCard
              icon='Formulations'
              preTitle='Continue where you left off'
              title={formulationName}
              href={href}
              isLoading={isLoadingFormulation || isCreatingFormulation}
            />
          ) : (
            <LandingPageFreeTierCard
              icon='Formulations'
              title='Create a Formulation'
              isLoading={isLoadingFormulation || isCreatingFormulation}
              onClick={onClick}
              // TODO: Add loom link when available
              // action={{
              //   text: 'See how this works',
              //   onClick: () => {
              //     // Redirect to the loom link
              //   },
              // }}
              addIcon
            />
          )}
          <LandingPageFreeTierCard
            icon='IngredientsSelected'
            title='Browse our Ingredient Library'
            onClick={() =>
              ingredientsRoute.redirect({
                input: {},
                params: {},
              })
            }
            isLoading={isLoadingFormulation}
            // TODO: Add loom link when available
            // action={{
            //   text: 'See how this works',
            //   onClick: () => {
            //     // Redirect to the loom link
            //   },
            // }}
          />
          <LandingPageFreeTierCard
            icon='RegulationsSelected'
            title='Search for Relevant Regulations'
            onClick={() =>
              regulationsRoute.redirect({
                input: {},
                params: {},
              })
            }
            isLoading={isLoadingFormulation}
            // TODO: Add loom link when available
            // action={{
            //   text: 'See how this works',
            //   onClick: () => {
            //     // Redirect to the loom link
            //   },
            // }}
          />
        </div>
      </div>
      <div className='flex justify-end'>
        <a
          href='https://www.loom.com/share/a15c27d9d1fe4b11a69a42c3e5f00a1b'
          target='_blank'
          rel='noopener noreferrer'
          className='flex flex-row gap-2 items-center cursor-pointer'
        >
          <Icon
            name='Information'
            height={20}
            width={20}
            className='text-blue-600'
          />
          <Text variant='smallSemi' color='text-blue-600'>
            See how to use these tools
          </Text>
        </a>
      </div>
    </div>
  );
};
